module.exports = __webpack_public_path__ + "static/media/diners.3689204b.svg";